import { Component } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'logo-header',
  templateUrl: 'logo-header.component.html',
  styleUrls: ['logo-header.component.scss'],
})
export class LogoHeaderComponent { }
